.root {
  display: inline-flex;
  align-items: center;
}

.icon {
  font-size: 22px;
  margin-left: 4px;
}
